import { cdnUrl } from '@platform/media';

export const ROUTES = {
  ROOT: '/',
  AUTH: 'auth',

  // Main
  ABOUT: 'about',
  STORE: 'store',
  /** 상품 상세. 파라미터 slug: xcost-pro | xpixels-aqc | xpixels-sqc | xpixels-eqc | xpixels-mqc */
  PRODUCT_DETAIL: 'products/:slug',
  DOWNLOAD_THANKS: 'download-thanks',

  // News (게시판 그룹 — 공지/업데이트/이벤트 등 확장)
  NEWS: 'news',
  NEWS_NOTICES: 'news/notices',
  NEWS_NOTICE_WRITE: 'news/notices/write',
  NEWS_NOTICE_DETAIL: 'news/notices/:id',
  NEWS_NOTICE_EDIT: 'news/notices/:id/edit',
  NEWS_UPDATES: 'news/updates',
  NEWS_UPDATE_WRITE: 'news/updates/write',
  NEWS_UPDATE_DETAIL: 'news/updates/:id',
  NEWS_UPDATE_EDIT: 'news/updates/:id/edit',
  NEWS_EVENTS: 'news/events',
  NEWS_EVENT_WRITE: 'news/events/write',
  NEWS_EVENT_DETAIL: 'news/events/:id',
  NEWS_EVENT_EDIT: 'news/events/:id/edit',
  NEWS_ARCHIVES: 'news/archives',
  NEWS_ARCHIVE_WRITE: 'news/archives/write',
  NEWS_ARCHIVE_DETAIL: 'news/archives/:id',
  NEWS_ARCHIVE_EDIT: 'news/archives/:id/edit',

  // My Page (마이페이지 — 로그인 필요)
  MYPAGE: 'mypage',

  // 견적함 (스토어 견적서 — 로그인 필요)
  QUOTES: 'quotes',
  QUOTE_DETAIL: 'quotes/:id',

  // 구독 재활성화 (일시정지 복구 — 로그인 필요)
  SUBSCRIPTION_REACTIVATE: 'subscription/reactivate/:id',

  // 결제 결과 (Toss 개인 카드결제 리다이렉트 — 최상위 /payments/*)
  // success: 승인(confirm) 처리 후 결과 표시 / fail: Toss 실패 코드 표시
  PAYMENT_SUCCESS: 'payments/success',
  PAYMENT_FAIL: 'payments/fail',
  // 자동결제(빌링) 카드등록 리다이렉트 — 구독 완성(billingKey→구독→최초청구)
  PAYMENT_BILLING_SUCCESS: 'payments/billing/success',
  PAYMENT_BILLING_FAIL: 'payments/billing/fail',

  // 중도해지 정산금 셀프 결제 (운영자가 발송한 링크 — **비로그인** 접근)
  // 인증은 URL 토큰(HMAC)이 대신한다. billing /v1/settlements 가 검증.
  SETTLEMENT_PAY: 'settlement/:token',

  // Coupon (쿠폰 등록 — 로그인 필요)
  COUPON: 'coupon',
  // Business (기업 콘솔 — 로그인 + BUSINESS 계정 필요. prefix 'business')
  BUSINESS: 'business',
  BUSINESS_MEMBERS: 'members',
  BUSINESS_LICENSES: 'licenses',
  BUSINESS_BILLING: 'billing',
  BUSINESS_VERIFICATION: 'verification',
  BUSINESS_PAYMENT_CONFIRM: 'payment/confirm',
  /** 기업콘솔(console-web) 진입 스텁. `?next=` 로 받은 콘솔 내부 경로로 넘긴다. */
  BUSINESS_CONSOLE: 'console',

  // Education (교육 접수 — 목록/과정 상세는 공개, 접수·내역은 로그인 필요)
  // educationRoutes 하위의 **상대** 경로다 (BUSINESS_* 와 같은 규칙).
  EDUCATION: 'education',
  EDUCATION_COURSE: 'courses/:id',
  /** 선택한 회차 결제. 장바구니는 EducationCartProvider(세션 저장)가 들고 있다. */
  EDUCATION_CHECKOUT: 'checkout',
  EDUCATION_REGISTRATIONS: 'registrations',
  EDUCATION_REGISTRATION_DETAIL: 'registrations/:id',

  // Support (지원 — FAQ / 1:1 문의)
  SUPPORT: 'support',
  // FAQ: 공개 열람(아코디언). 작성/수정은 운영자.
  SUPPORT_FAQS: 'support/faqs',
  SUPPORT_FAQ_WRITE: 'support/faqs/write',
  SUPPORT_FAQ_EDIT: 'support/faqs/:id/edit',
  // 1:1 문의: 전 경로 로그인 필요.
  SUPPORT_INQUIRIES: 'support/inquiries',
  SUPPORT_INQUIRY_WRITE: 'support/inquiries/write',
  SUPPORT_INQUIRY_DETAIL: 'support/inquiries/:id',
  SUPPORT_INQUIRY_EDIT: 'support/inquiries/:id/edit',
  // 협업(파트너십) 문의: 비로그인도 작성·제출 가능(공개 라우트).
  SUPPORT_COLLABORATION: 'support/collaboration',

  // Docs (도움말 — 공개. 본문은 레포에 번들된 MDX 라 서버 호출이 없다)
  // 아래 두 개는 docsRoutes 하위의 **상대** 경로다 (BUSINESS_* 와 같은 규칙).
  DOCS: 'docs',
  /** 섹션 인덱스. 자체 화면 없이 해당 섹션의 첫 문서로 replace 이동한다. */
  DOCS_SECTION: ':section',
  DOCS_ARTICLE: ':section/:slug',
  // 관리(ADMIN+). `:section` 보다 정적 세그먼트가 우선 매칭된다.
  // 서버 RESERVED_SECTION_SLUGS 에 'manage' 가 들어 있어야 섹션 slug 와 안 겹친다.
  DOCS_MANAGE: 'manage',
  DOCS_MANAGE_NEW: 'manage/new',
  DOCS_MANAGE_EDIT: 'manage/:id',

  // Pumsem (품셈해설 — 공개. 표·[주]는 core-service 가 판별로 소유한다)
  // pumsemRoutes 하위의 **상대** 경로다.
  PUMSEM: 'pumsem',
  /** 항목 상세. 판은 경로가 아니라 `?edition=` 쿼리다(없으면 최신 발행판). */
  PUMSEM_ITEM: ':division/:code',
  /** 직전 판 대비 비교. 임의 두 판 비교는 서버가 제공하지 않는다. */
  PUMSEM_DIFF: ':division/:code/diff',
  // 관리(ADMIN+). `:division` 보다 정적 세그먼트가 우선 매칭된다.
  PUMSEM_MANAGE: 'manage',
  PUMSEM_MANAGE_NEW: 'manage/new',
  PUMSEM_MANAGE_EDIT: 'manage/:revisionId',

  // Auth (prefix 'auth' — authRoutes.tsx에서 부여)
  LOGIN: 'login',
  SIGNUP: 'signup',
  REQUEST_PASSWORD_RESET: 'request-password-reset',
  // 이메일 로그인을 없앤 뒤 아이디를 잊으면 자력 복구가 막힌다 — 필수 경로.
  FIND_LOGIN_ID: 'find-login-id',
  // Owner 가 만든 구성원 계정·구버전 이관 계정의 첫 로그인 강제 절차.
  ONBOARDING: 'onboarding',
  // 약관 개정 후 로그인 시 강제 재동의.
  RECONSENT: 'reconsent',
  VERIFY_EMAIL: 'verify-email',
  CONFIRM_EMAIL_CHANGE: 'confirm-email-change',
  RESET_PASSWORD: 'reset-password',

  // Desktop (XCOST 브라우저 로그인 — 로그인 필요). desktopRoutes 하위의 **상대** 경로다.
  DESKTOP: 'desktop',
  /** XCOST 가 시스템 브라우저로 여는 동의 화면. 쿼리는 OAuth 표준 snake_case 다. */
  DESKTOP_AUTHORIZE: 'authorize',
  /** 등록 PC 가 가득 찼을 때 동의 화면이 보내는 기기 정리 화면(해제만 한다). */
  DESKTOP_DEVICES: 'devices',
  /** XCOST 루프백이 302 로 보내는 로그인 완료 화면(로그인 불필요). 쿼리 result=success|denied|invalid */
  DESKTOP_COMPLETE: 'complete',

  // Legal (약관/개인정보/환불정책 — 공개)
  LEGAL_TERMS: 'legal/terms',
  LEGAL_PRIVACY: 'legal/privacy',
  // 구매 모달의 "환불·해지 정책" 링크가 바로 이 문서를 연다. 이용약관 안의 한 절을
  // 링크하면 사용자가 찾지 못해 중요내용 설명의무 이행 근거로 약하다.
  LEGAL_REFUND: 'legal/refund',

  // Error
  UNAUTHORIZED: 'unauthorized',
} as const;

export const PRODUCT_SLUG = {
  XCOST_PRO: 'xcost-pro',
  XPIXELS_AQC: 'xpixels-aqc',
  XPIXELS_SQC: 'xpixels-sqc',
  XPIXELS_EQC: 'xpixels-eqc',
  XPIXELS_MQC: 'xpixels-mqc',
  WORKNOTE: 'worknote',
} as const;

/** 알려진 상품 slug. navigationItems.ts와 product 데이터 키와 일치해야 함. */
export const PRODUCT_SLUGS = [
  PRODUCT_SLUG.XCOST_PRO,
  PRODUCT_SLUG.XPIXELS_AQC,
  PRODUCT_SLUG.XPIXELS_SQC,
  PRODUCT_SLUG.XPIXELS_EQC,
  PRODUCT_SLUG.XPIXELS_MQC,
  PRODUCT_SLUG.WORKNOTE,
] as const;

export type ProductSlug = (typeof PRODUCT_SLUGS)[number];

/** 게시판 타입 — boardConfig 키와 일치 (BE BOARD_TYPE 과 동일) */
export const BOARD_TYPES = [
  'notices',
  'updates',
  'events',
  'faqs',
  'archives',
] as const;
export type BoardType = (typeof BOARD_TYPES)[number];

/**
 * 마이페이지 탭 — `?tab=` 에 그대로 실리므로 라우트 어휘로 둔다.
 * 배열 순서가 화면 탭 순서다. 라벨과 파싱은 features/mypage 가 맡는다.
 */
export const MYPAGE_TABS = [
  'profile',
  'licenses',
  'devices',
  'password',
  'payments',
] as const;
export type MypageTab = (typeof MYPAGE_TABS)[number];

// path 조합 헬퍼 — Link/navigate에서 사용
export const PATHS = {
  HOME: '/',
  ABOUT: `/${ROUTES.ABOUT}`,
  STORE: `/${ROUTES.STORE}`,
  DOWNLOAD_THANKS: `/${ROUTES.DOWNLOAD_THANKS}`,

  /* PRODUCTS */
  productDetail: (slug: ProductSlug) => `/products/${slug}`,
  PRODUCT_XCOST_PRO: '/products/xcost-pro',
  PRODUCT_XPIXELS_AQC: '/products/xpixels-aqc',
  PRODUCT_XPIXELS_SQC: '/products/xpixels-sqc',
  PRODUCT_XPIXELS_EQC: '/products/xpixels-eqc',
  PRODUCT_XPIXELS_MQC: '/products/xpixels-mqc',
  PRODUCT_WORKNOTE: '/products/worknote',

  /* NEWS (게시판) */
  NEWS_NOTICES: '/news/notices',
  NEWS_UPDATES: '/news/updates',
  NEWS_EVENTS: '/news/events',
  NEWS_ARCHIVES: '/news/archives',
  noticeDetail: (id: string | number) => `${PATHS.NEWS_NOTICES}/${id}`,
  updateDetail: (id: string | number) => `${PATHS.NEWS_UPDATES}/${id}`,
  eventDetail: (id: string | number) => `${PATHS.NEWS_EVENTS}/${id}`,
  archiveDetail: (id: string | number) => `${PATHS.NEWS_ARCHIVES}/${id}`,
  noticeWrite: () => `${PATHS.NEWS_NOTICES}/write`,
  updateWrite: () => `${PATHS.NEWS_UPDATES}/write`,
  eventWrite: () => `${PATHS.NEWS_EVENTS}/write`,
  archiveWrite: () => `${PATHS.NEWS_ARCHIVES}/write`,
  noticeEdit: (id: string | number) => `${PATHS.NEWS_NOTICES}/${id}/edit`,
  updateEdit: (id: string | number) => `${PATHS.NEWS_UPDATES}/${id}/edit`,
  eventEdit: (id: string | number) => `${PATHS.NEWS_EVENTS}/${id}/edit`,
  archiveEdit: (id: string | number) =>
    `${PATHS.NEWS_ARCHIVES}/${id}/edit`,

  /* MY PAGE */
  MYPAGE: '/mypage',
  /** 탭 딥링크. 결제 완료·쿠폰 등록처럼 '어디를 볼지'가 정해진 이동에 쓴다. */
  mypageTab: (tab: MypageTab) => `/mypage?tab=${tab}`,

  /* 견적함 (스토어 견적서) */
  QUOTES: '/quotes',
  quoteDetail: (id: string) => `/quotes/${id}`,

  /* 구독 재활성화 */
  subscriptionReactivate: (id: string) => `/subscription/reactivate/${id}`,

  /* 결제 결과 (Toss 개인 카드결제 리다이렉트) */
  PAYMENT_SUCCESS: '/payments/success',
  PAYMENT_FAIL: '/payments/fail',
  /* 자동결제(빌링) 카드등록 리다이렉트 */
  PAYMENT_BILLING_SUCCESS: '/payments/billing/success',
  PAYMENT_BILLING_FAIL: '/payments/billing/fail',

  /* COUPON (쿠폰 등록) */
  COUPON: '/coupon',
  /* 조직 초대 수락 */

  /* BUSINESS (기업 콘솔) */
  BUSINESS: '/business',
  BUSINESS_MEMBERS: '/business/members',
  BUSINESS_LICENSES: '/business/licenses',
  BUSINESS_BILLING: '/business/billing',
  BUSINESS_VERIFICATION: '/business/verification',
  BUSINESS_PAYMENT_CONFIRM: '/business/payment/confirm',
  BUSINESS_CONSOLE: '/business/console',

  /* EDUCATION (교육) */
  EDUCATION: `/${ROUTES.EDUCATION}`,
  educationCourse: (id: string) => `/${ROUTES.EDUCATION}/courses/${id}`,
  EDUCATION_CHECKOUT: `/${ROUTES.EDUCATION}/checkout`,
  EDUCATION_REGISTRATIONS: `/${ROUTES.EDUCATION}/registrations`,
  educationRegistration: (id: string) =>
    `/${ROUTES.EDUCATION}/registrations/${id}`,

  /* SUPPORT (지원) */
  SUPPORT_FAQS: '/support/faqs',
  SUPPORT_INQUIRIES: '/support/inquiries',
  faqWrite: () => `/support/faqs/write`,
  faqEdit: (id: string | number) => `/support/faqs/${id}/edit`,
  inquiryDetail: (id: string | number) => `/support/inquiries/${id}`,
  inquiryWrite: () => `/support/inquiries/write`,
  inquiryEdit: (id: string | number) => `/support/inquiries/${id}/edit`,
  /** 협업 문의 작성(공개). product slug 를 쿼리로 넘기면 폼에서 관심 제품이 선택됨. */
  SUPPORT_COLLABORATION: '/support/collaboration',
  collaborationWrite: (productSlug?: string) =>
    productSlug
      ? `/support/collaboration?product=${encodeURIComponent(productSlug)}`
      : '/support/collaboration',

  /* DOCS (도움말) */
  DOCS: '/docs',
  docsSection: (section: string) => `/docs/${section}`,
  docsArticle: (section: string, slug: string) => `/docs/${section}/${slug}`,
  DOCS_MANAGE: '/docs/manage',
  DOCS_MANAGE_NEW: '/docs/manage/new',
  docsManageEdit: (id: string) => `/docs/manage/${id}`,

  /* PUMSEM (품셈해설) */
  PUMSEM: '/pumsem',
  pumsemItem: (division: string, code: string) => `/pumsem/${division}/${code}`,
  pumsemDiff: (division: string, code: string) =>
    `/pumsem/${division}/${code}/diff`,
  PUMSEM_MANAGE: '/pumsem/manage',
  PUMSEM_MANAGE_NEW: '/pumsem/manage/new',
  pumsemManageEdit: (revisionId: string) => `/pumsem/manage/${revisionId}`,

  /* AUTH - path: '/auth' */
  LOGIN: `/${ROUTES.AUTH}/${ROUTES.LOGIN}`,
  SIGNUP: `/${ROUTES.AUTH}/${ROUTES.SIGNUP}`,
  REQUEST_PASSWORD_RESET: `/${ROUTES.AUTH}/${ROUTES.REQUEST_PASSWORD_RESET}`,
  FIND_LOGIN_ID: `/${ROUTES.AUTH}/${ROUTES.FIND_LOGIN_ID}`,
  ONBOARDING: `/${ROUTES.AUTH}/${ROUTES.ONBOARDING}`,
  RECONSENT: `/${ROUTES.AUTH}/${ROUTES.RECONSENT}`,
  VERIFY_EMAIL: `/${ROUTES.AUTH}/${ROUTES.VERIFY_EMAIL}`,
  CONFIRM_EMAIL_CHANGE: `/${ROUTES.AUTH}/${ROUTES.CONFIRM_EMAIL_CHANGE}`,
  RESET_PASSWORD: `/${ROUTES.AUTH}/${ROUTES.RESET_PASSWORD}`,

  /* DESKTOP (XCOST 브라우저 로그인) */
  DESKTOP_AUTHORIZE: `/${ROUTES.DESKTOP}/${ROUTES.DESKTOP_AUTHORIZE}`,
  DESKTOP_DEVICES: `/${ROUTES.DESKTOP}/${ROUTES.DESKTOP_DEVICES}`,
  DESKTOP_COMPLETE: `/${ROUTES.DESKTOP}/${ROUTES.DESKTOP_COMPLETE}`,

  /* STORE QUERY 헬퍼 (CTA에서 사용) */
  STORE_INDIVIDUAL: '/store?type=INDIVIDUAL',
  STORE_BUSINESS: '/store?type=BUSINESS',

  /* LEGAL (약관/개인정보/환불정책) */
  LEGAL_TERMS: `/${ROUTES.LEGAL_TERMS}`,
  LEGAL_PRIVACY: `/${ROUTES.LEGAL_PRIVACY}`,
  LEGAL_REFUND: `/${ROUTES.LEGAL_REFUND}`,

  /* 그 외 (*) */
  UNAUTHORIZED: `/${ROUTES.UNAUTHORIZED}`,
} as const;

// 외부 URL
export const EXTERNAL_URL = {
  // 프로그램 다운로드 — TODO: 실제 CDN 경로 확정 후 교체
  SETUP_DOWNLOAD: cdnUrl('download/setup/HOWCOST_TOOLS_Setup.exe'),
  // 구버전 프로그램 다운로드
  SETUP_DOWNLOAD_LEGACY: cdnUrl('download/setup/XCOST_PRO_Legacy_Setup.exe'),
  // 통합내역 유튜브
  PRO_YOUTUBE:
    'https://youtube.com/playlist?list=PLCDsxyj88FbYESZgbWmGSUVO3KcTneW9z&si=0H1P_2FH2M4tqY7N',
  // 마감수량산출 유튜브
  AQC_YOUTUBE:
    'https://youtube.com/playlist?list=PLCDsxyj88FbYpkTPrKMpt1sImzymb_PsT&si=EyBrMsyjopVwEwrD',
  // 구조수량산출 유튜브
  SQC_YOUTUBE:
    'https://youtube.com/playlist?list=PLCDsxyj88FbYjKaqVQr1nVQhapTYYMHAT&si=CYPh-TjjDJONuE4i',
  // 커뮤니티 사이트
  COMMUNITY: 'https://xcost.me/',
  // 대표님 네이버 블로그
  NAVER_BLOG: 'https://blog.naver.com/mycost',
  // 네이버 밴드
  NAVER_BAND: 'https://www.band.us/@xcost',
  // 도움말 — 내부 /docs 로 대체됨(PATHS.DOCS). 구버전 클라이언트가 여는
  // 외부 주소라 상수는 남겨두되 앱 안에서 링크로 쓰지 않는다.
  HOWCOST_DOCS: 'https://www.howcost.co.kr/docs',
  // 품셈해설 — 내부 /pumsem 으로 대체됨(PATHS.PUMSEM). 구버전 클라이언트가 여는
  // 외부 주소라 상수는 남겨두되 앱 안에서 링크로 쓰지 않는다(HOWCOST_DOCS 와 같은 규약).
  HOWCOST_STD_PROD: 'https://www.howcost.co.kr/stdprod',
} as const;
